import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { BUTTON_WIDTH } from 'src/config/styles'
import { Theme } from '@mui/material/styles'

export default createUseStyles({
  calendarButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  calendarButton: {
    width: BUTTON_WIDTH,
    [forPhoneOnly]: {
      width: '100%',
    },
  },
})

export const PopoverStyles = (theme: Theme) => ({
  zIndex: 2300,
  '.MuiPopover-paper': {
    width: 311,
  },
  '.MuiListItemText-root': {
    marginTop: 0,
    marginBottom: 0,
  },
  '.MuiListItemIcon-root': {
    minWidth: 0,
    marginRight: '12px',
  },
  '.MuiListItemButton-root:hover': {
    background: theme.palette.primary['50'],
  },
})
